import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/auth-slice";
import roleReducer from "./features/roles-slice";
import userReducer from "./features/user-slice";
import { commandReducer } from "./features/command";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    roleState: roleReducer,
    user: userReducer,
    command: commandReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
